// VAPI Configuration
export const VAPI_LIST_KEY = '90bf70f3-6fec-464b-9d6c-e8069b77c599'
export const VAPI_CLIENT_KEY = 'dec17c52-3662-4f8a-842d-251d1c783e5e' 